import { areLocationScopesEqual } from './locationScopes';
import { locationStatusKey } from './adminLocationStatus';

export const LOCATION_REVIEW_STATUS_FIELD = 'locationReviewStatus';
export const LOCATION_REVIEW_FILTER_OPTIONS = Object.freeze([
  { value: 'up_to_date', label: 'Todo está al día' },
  { value: 'needs_review', label: 'Requiere revisión' },
]);

// Older saved filters remain usable after merging unconfirmed into needs_review.
export function normalizeLocationReviewStatus(value) {
  return ['unconfirmed', 'not_up_to_date'].includes(value) ? 'needs_review' : value;
}

export function getLocationReviewFilterLabel(value) {
  return LOCATION_REVIEW_FILTER_OPTIONS.find((option) => option.value === normalizeLocationReviewStatus(value))?.label || String(value || '');
}

export function getRelevantLocationReviewScopes(locations, { selectedLocationScope, authorizedScopes } = {}) {
  const selected = selectedLocationScope
    ? locations.filter((location) => areLocationScopesEqual(location, selectedLocationScope))
    : locations;
  return authorizedScopes
    ? selected.filter((location) => authorizedScopes.some((scope) => areLocationScopesEqual(scope, location)))
    : selected;
}

export function createLocationReviewIndex(statuses) {
  return new Map(statuses.map((entry) => [locationStatusKey(entry.locationScope), entry.status === 'up_to_date' ? 'up_to_date' : 'needs_review']));
}

export function getUserLocationReviewValue(locations, statusIndex, { loading = false, error = '' } = {}) {
  if (loading || error) return { available: false, states: [] };
  return {
    available: true,
    states: [...new Set(locations.map((location) => statusIndex.get(locationStatusKey(location)) || 'needs_review'))],
  };
}

export function doesLocationReviewMatchFilter(value, filterItem) {
  if (!value?.available || !value.states.length) return false;
  switch (normalizeLocationReviewStatus(filterItem?.value)) {
    case 'up_to_date':
      return value.states.every((status) => status === 'up_to_date');
    case 'needs_review':
      return value.states.some((status) => status !== 'up_to_date');
    default:
      return true;
  }
}
